import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { X } from 'lucide-react';
import { changeSellerPassword } from '../../../../features/sellers/sellerDetailsThunks';
import { Button } from '../../../../components/ui/Button';

export const ChangePasswordModal = ({ sellerId, isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { passwordChanging } = useSelector(state => state.sellerDetails);

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    dispatch(changeSellerPassword({ sellerId, tempPassword: password }))
      .unwrap()
      .then(() => {
        alert("Contraseña cambiada exitosamente");
        setPassword('');
        setConfirmPassword('');
        onClose();
      })
      .catch((err) => {
        setError(err || 'Hubo un error al cambiar la contraseña');
      });
  };

  const modalContent = (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div
        role="dialog"
        aria-modal="true"
        data-testid="seller-password-modal"
        className="bg-white dark:bg-[#1a1a1a] rounded-2xl w-full max-w-md p-6 shadow-xl border border-border relative">
        <button
          onClick={onClose}
          disabled={passwordChanging}
          className="absolute top-4 right-4 text-text-muted hover:text-ninja-dark dark:hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <X size={20} />
        </button>

        <h3 className="text-xl font-bold text-ninja-dark dark:text-white mb-2">Cambiar Contraseña</h3>
        <p className="text-sm text-text-secondary mb-6">Genera una nueva contraseña para el seller.</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-semibold text-ninja-dark dark:text-white mb-1">Nueva Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-ninja-gray dark:bg-[#2d2d2d] border border-border rounded-xl px-4 py-2.5 text-sm text-ninja-dark dark:text-white outline-none focus:border-ninja-green transition-colors"
              placeholder="••••••••"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-ninja-dark dark:text-white mb-1">Confirmar Contraseña</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full bg-ninja-gray dark:bg-[#2d2d2d] border border-border rounded-xl px-4 py-2.5 text-sm text-ninja-dark dark:text-white outline-none focus:border-ninja-green transition-colors"
              placeholder="••••••••"
              required
            />
          </div>

          {error && <p className="text-danger text-sm">{error}</p>}

          <div className="pt-2">
            <Button
              type="submit"
              variant="primary"
              size="lg"
              fullWidth
              loading={passwordChanging}
              loadingLabel="Cambiando..."
            >
              Guardar Contraseña
            </Button>
          </div>
        </form>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};
